import type {
  ClientResponse,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/post-request-filter-set/post-request-filter-set.types'
import { handleSuccess } from '@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/post-request-filter-set/services/handle-success'
import type { PatchRequestFilterSetPayload } from '@onhandtech/onhand-fe-shared/lib/contracts/api/v5/request-filter-set/request-filter-set'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { createRequestError } from '@onhandtech/onhand-fe-shared/lib/request'
import type { AxiosError } from 'axios'

export const moduleName = 'patch-request-filter-set'

const args: RequestArgs<ServerResponse, ClientResponse, never, PatchRequestFilterSetPayload> = {
  method: 'PATCH',
  url: '',
  handleSuccess,
  handleFailure: (error: AxiosError) =>
    createRequestError(error, error.status?.toString() ?? '', moduleName),
}

const patchRequestFilterSetsModule = () =>
  createReduxServiceModule<ServerResponse, ClientResponse, never, PatchRequestFilterSetPayload>({
    moduleName,
    args,
  })

export default patchRequestFilterSetsModule
